module.exports = __webpack_public_path__ + "../resources/images/new-event-module-cf2a6b9658f78a03141ea287b43039b8.png";